import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Button, Modal, Spacer, Typography } from '@telus-uds/components-web';

const RegistrationModel = ({ show = false, labels }) => {
  const [showModal, setShowModal] = useState(show);
  const { emailConfirmation, confirmationMessage } = labels;
  const history = useHistory();
  const closeModal = () => {
    setShowModal(false);
  };
  const proceed = () => {
    setShowModal(false);
    history.push('/login');
  };

  return (
    <div>
      <Modal
        isOpen={showModal}
        onClose={closeModal}
      >
        <Typography variant={{ size: 'h2' }}>{emailConfirmation}</Typography>
        <Spacer space={1} />
        <p>{confirmationMessage}</p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '1rem' }}>
          <Button
            type="button"
            variant={{ priority: 'high' }}
            onPress={proceed}
          >
            Continue
          </Button>
        </div>
      </Modal>
    </div>
  );
};

RegistrationModel.propTypes = {
  show: PropTypes.bool,
  labels: PropTypes.shape({
    emailConfirmation: PropTypes.string,
    confirmationMessage: PropTypes.string,
    close: PropTypes.string
  }).isRequired
};

export default RegistrationModel;
